import { render, staticRenderFns } from "./ChooseLaboratoryButton.vue?vue&type=template&id=9320f3ec&"
import script from "./ChooseLaboratoryButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChooseLaboratoryButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9320f3ec')) {
      api.createRecord('9320f3ec', component.options)
    } else {
      api.reload('9320f3ec', component.options)
    }
    module.hot.accept("./ChooseLaboratoryButton.vue?vue&type=template&id=9320f3ec&", function () {
      api.rerender('9320f3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/pages/AnalysesListPage/components/DiscountBanner/components/ChooseLaboratoryButton.vue"
export default component.exports